import { NgModule } from "@angular/core";
import { FooterComponent } from "./footer.component";
import { DisclaimerModule } from "../disclaimer/disclaimer.module";
import { CommonModule } from "@angular/common";
import { ImprintModule } from "../imprint/imprint.module";
import { L10nTranslationModule } from "angular-l10n";
import { DialogModule } from "primeng/dialog";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [
    FooterComponent
  ],
  exports: [
    FooterComponent
  ],
  imports: [
    CommonModule,
    DisclaimerModule,
    ImprintModule,
    L10nTranslationModule,
    DialogModule,
    FontAwesomeModule
  ]
})
export class FooterModule {
}
